import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Progress,
  Spinner,
  Nav,
  NavItem,
  TabContent,
  NavLink,
  TabPane,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import logo from "../../../../assets/images/karak_logo_new.png";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  columnsProductDetails,
  columnsProductInbound,
  columnsProductInboundDetails,
  columnsProductOutbound,
  columnsProductOutboundDetails,
  columnsPurchase,
  columnsPurchaseDetails,
  columnsPurchaseTabDeatils,
} from "./COGSProductColumns";
import moment from "moment";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import { getDateRangeFromMonth, mergeDuplicateItemsQuantityForStore, mergeDuplicateProdQuantity, mergeDuplicateProducts, mergeDuplicateProductsQuantityForOpening } from "../../../../helpers/commonFunctions";

const flattenPurchaseTabRows = (rows) =>
  (rows || []).map((row, index) => ({
    ...row,
    row_key: row._id ? `${row._id}_${index}` : `row_${index}`,
    dd_seq_no: row.delivery_details?.seq_no,
    dd_name: row.delivery_details?.name || "",
    dd_is_free: !!row.delivery_details?.is_free,
    dd_unit_for_cost_price: row.delivery_details?.unit_for_cost_price,
    dd_cost_price: row.delivery_details?.cost_price,
    dd_receiving_cost: row.delivery_details?.receiving_cost,
  }));

const CostOfGoodsSoldProductsReport = (props) => {
  const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState();
  const [currentMonthYear, setCurrentMonthYear] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [filterModalTotal, setFilterModalTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const ordersRequestId = useRef(0);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  function afterFilter(newResult) {
    const total = (newResult || [])
      .reduce(
        (partialSum, a) => Number(partialSum) + Number(a.receiving_cost || 0),
        0
      )
      .toFixed(2);
    setFilterModalTotal((prev) => (String(prev) === total ? prev : total));
  }

  function afterFilterForTabDetails(newData, quantityField, detailsType = 'delivery_details') {     
     const data = newData || [];
     let totalCost = 0;
     let totalLowestUnitQty = 0;
     
     data.forEach(item => {
       const details = item[detailsType];
       const { 
         receiving_cost = 0,
         cost = 0,
         unit_levels,
         received_quantity,
         receive,
         quantity
       } = details || {};   
       totalCost += Number(receiving_cost || 0);
   
       if (unit_levels) {
         const quantityToBeDisplayed = 
           quantityField === 'received_quantity' ? received_quantity : 
           quantityField === 'receive' ? receive : 
           quantity;
   
         if (quantityToBeDisplayed) {
           const convertedQty = convertToLowestUnit(unit_levels, quantityToBeDisplayed);
           totalLowestUnitQty += Number(convertedQty || 0);
         }
       }
     });
   
     let displayQuantity = "";
     const firstItemDetails = data[0]?.[detailsType];
     if (firstItemDetails?.unit_levels) {
       const { unit_levels } = firstItemDetails;
       const lowestUnit = unit_levels.at(-1).unit;
       
       const summedQuantity = [{
         unit: lowestUnit,
         value: totalLowestUnitQty
       }];
       
       displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
     }

     const nextSubTotal = totalCost.toFixed(2);
     setFilterModalTotalQty((prev) =>
       JSON.stringify(prev) === JSON.stringify(displayQuantity) ? prev : displayQuantity
     );
     setFilterModalSubTotal((prev) =>
       String(prev) === nextSubTotal ? prev : nextSubTotal
     );
   }
  
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    setMonthYear(formatDate(currentDay).slice(0, 7));
    setCurrentMonthYear(formatDate(currentDay).slice(0, 7));
    loadAllBranches()
  }, []);

  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoading(true);
      setProgress(0);
      setAllOrders([]);

      const url =
        process.env.REACT_APP_BASEURL + "reports/cost_of_goods_sold_products_report";
      const mapBranches = (branches) =>
        (branches || []).map((branch) => ({
          ...branch,
          id: branch.id || branch._id,
        }));

      if (monthYear === currentMonthYear) {
        const branchIds = allBranches.map((branch) => branch._id);
        const batches = [];
        for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
          batches.push(branchIds.slice(i, i + BATCH_SIZE));
        }
        const totalBatches = batches.length || 1;
        let completed = 0;
        let nextIndex = 0;

        const runWorker = async () => {
          while (nextIndex < batches.length) {
            if (requestId !== ordersRequestId.current) return;
            const index = nextIndex++;
            const payload = {
              monthYear: monthYear,
              branch_ids: batches[index],
              summary_only: true,
            };
            try {
              const batchResponse = await postSubmitForm(url, payload);
              if (requestId !== ordersRequestId.current) return;
              if (batchResponse && batchResponse.status === 1) {
                const newBranchData = mapBranches(
                  batchResponse.data.branches || []
                );
                setAllOrders((prevOrders) => {
                  const newBranchIds = new Set(
                    newBranchData.map((branch) => String(branch._id))
                  );
                  const filteredPrevOrders = prevOrders.filter(
                    (order) => !newBranchIds.has(String(order._id))
                  );
                  return [...filteredPrevOrders, ...newBranchData];
                });
              }
            } catch (batchError) {
              console.error(`Error processing batch ${index + 1}:`, batchError);
            } finally {
              completed += 1;
              setProgress(Math.round((completed / totalBatches) * 100));
            }
          }
        };

        const workers = Math.min(CONCURRENCY, batches.length || 1);
        await Promise.all(
          Array.from({ length: workers }, () => runWorker())
        );
      } else {
        const res = await postSubmitForm(url, {
          monthYear: monthYear,
          summary_only: true,
        });
        if (requestId !== ordersRequestId.current) return;
        if (res.status === 1) {
          setAllOrders(mapBranches(res.data.branches));
        } else {
          showNotification(res.message, "Error");
        }
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.error("Error loading orders:", error);
      showNotification("Error loading data", "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 400));
        if (requestId === ordersRequestId.current) {
          setIsLoading(false);
        }
      }
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [allBranches, setAllBranches] = useState([]);
  const [progress, setProgress] = useState(0);
  const BATCH_SIZE = 10;
  const CONCURRENCY = 2;
  const branchDetailsInFlight = useRef({}); 

  const loadAllBranches = async () => {
   try {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store) => store.type === "Branch" || store.type === "CENTRAL STORE" || store.type === "CENTRAL KITCHEN STORE" && store.is_active === true)
      // const res = response.data.filter((store) => (store.type === "CENTRAL KITCHEN STORE" || store.name === "ABUSAMRA"))
      // const sorted =  res.sort((a, b) => a.name.localeCompare(b.name)) 
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.error(error)
   }
  };

  useEffect(() => {
    let isMounted = true;
  
    const fetchData = async () => {
      if (monthYear && allBranches.length > 0) {
        setAllOrders([]);
        if (isMounted) {
          await loadOrders();
        }
      }
    };
  
    fetchData();
  
    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [monthYear, allBranches]);

  const [purchaseModal, setPurchaseModal] = useState(false);
  const [openingModal, setOpeningModal] = useState(false);
  const [closingModal, setClosingModal] = useState(false);
  const [productOutboundModal, setProductOutboundModal] = useState(false);
  const [productInboundModal, setProductInboundModal] = useState(false);

  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [productOutboundDetailsModal, setProductOutboundDetailsModal] = useState(false);
  const [productInboundDetailsModal, setProductInboundDetailsModal] = useState(false);

  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [productOutboundDetails, setProductOutboundDetails] = useState([]);
  const [productInboundDetails, setProductInboundDetails] = useState([]);

  const [productManualEntry, setProductManualEntry] = useState([]);
  const [centralKitchenTabDetails, setCentralKitchenTabDetails] = useState([]);

  const dateFrom = moment(monthYear).startOf("month").format("YYYY-MM-DD");
  const dateTo = moment(monthYear).endOf("month").format("YYYY-MM-DD");

  const loadPurchaseDetails = async (item_id) => {
    try {

      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_product_orders";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        from_cogs:true,
       product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;  
        
        data.forEach(item => {
          const { delivery_details } = item;
          const { 
            receiving_cost = 0,
            unit_levels,
            received_quantity
          } = delivery_details || {};
  
          totalReceivingCost += Number(receiving_cost);
  
          if (unit_levels && received_quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, received_quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });
  
        // Get display quantity if possible
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;
          
          const summedQuantity = [{
            unit: lowestUnit,
            value: totalLowestUnitQty
          }];
          
          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);          
        }
  

        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setPurchaseDetails(response.data);
        setPurchaseDetailsModal(!purchaseDetailsModal);
      } else {

        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {

    }
  };

   const loadTabProductDetails = async (item_id,tab) => {
    try {
      const is_manual = tab === 2 ;

      let url = '';
        url =process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_product_po";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        from_cogs:true,
        is_manual:is_manual,
       product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;  
        
        data.forEach(item => {
          const { delivery_details } = item;
          const { 
            receiving_cost = 0,
            unit_levels,
            // received_quantity,
            receive
          } = delivery_details || {};
  
          totalReceivingCost += Number(receiving_cost);
  
          if (unit_levels && receive) {
            const convertedQty = convertToLowestUnit(unit_levels, receive);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });
  
        // Get display quantity if possible
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;
          
          const summedQuantity = [{
            unit: lowestUnit,
            value: totalLowestUnitQty
          }];
          
          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);          
        }
  

        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setCentralKitchenTabDetails(flattenPurchaseTabRows(response.data));
        setPurchaseDetailsModal(!purchaseDetailsModal);
      } else {

        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {

    }
  };

  const loadProductInboundDetails = async (item_id) => {
    try {

      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_transfers_inbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;  
        
        data.forEach(item => {
          const { product_details } = item;
          const { 
            receiving_cost = 0,
            unit_levels,
            quantity
          } = product_details || {};
  
          totalReceivingCost += Number(receiving_cost || 0);
  
          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });
  
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.product_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;
          
          const summedQuantity = [{
            unit: lowestUnit,
            value: totalLowestUnitQty
          }];
          
          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }

        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductInboundDetails(response.data);
        setProductInboundDetailsModal(true);
      } else {

        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {

    }
  };

  const loadProductOutboundDetails = async (item_id) => {
    try {

      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_transfers_outbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;  
      
      data.forEach(item => {
        const { product_details } = item;
        const { 
          receiving_cost = 0,
          unit_levels,
          quantity
        } = product_details || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && quantity) {
          const convertedQty = convertToLowestUnit(unit_levels, quantity);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });
      let displayQuantity = "";
      const firstDeliveryDetails = data[0]?.product_details;
      if (firstDeliveryDetails?.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        
        const summedQuantity = [{
          unit: lowestUnit,
          value: totalLowestUnitQty
        }];
        
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }

        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductOutboundDetails(response.data);
        setProductOutboundDetailsModal(true);
      } else {

        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {

    }
  };  

       const getPositiveNumber = (value) => {
        const num = Number(value || 0);
        return num > 0 ? num : 0;
      };

      const calculateCOGS = (row) => {
        const cogs =
          Number(row.product_cost_opening ? row.product_cost_opening : 0) +
          Number(row.product_purchase_cost) +
          Number(row.product_inbound_transfer_cost) -
          Number(row.product_outbound_transfer_cost) -
          Number(row.product_cost);
        
        return isNaN(cogs) ? 0 : cogs;
      };

  const branchHasDetails = (row) =>
    !!(
      row &&
      (row._detailsLoaded ||
        (row.product_details && row.product_details.length) ||
        (row.product_details_opening && row.product_details_opening.length) ||
        (row.product_order_details && row.product_order_details.length) ||
        (row.product_purchase_details && row.product_purchase_details.length) ||
        (row.product_transfer_details && row.product_transfer_details.length))
    );

  const ensureBranchDetails = async (row) => {
    if (!row || !row._id) return row;
    if (branchHasDetails(row)) return row;
    const rowId = String(row._id);
    if (branchDetailsInFlight.current[rowId]) {
      return branchDetailsInFlight.current[rowId];
    }
    branchDetailsInFlight.current[rowId] = (async () => {
      try {
        const url =
          process.env.REACT_APP_BASEURL +
          "reports/cost_of_goods_sold_products_report";
        const res = await postSubmitForm(url, {
          monthYear,
          branch_ids: [row._id],
          summary_only: false,
        });
        if (res && res.status === 1) {
          const full = (res.data.branches || []).find(
            (branch) => String(branch._id) === rowId
          );
          if (full) {
            const merged = { ...row, ...full, _detailsLoaded: true };
            setAllOrders((prev) =>
              prev.map((branch) =>
                String(branch._id) === rowId
                  ? { ...branch, ...full, _detailsLoaded: true }
                  : branch
              )
            );
            return merged;
          }
        } else {
          showNotification((res && res.message) || "Error", "Error");
        }
      } catch (error) {
        console.error(error);
        showNotification("Error loading details", "Error");
      } finally {
        delete branchDetailsInFlight.current[rowId];
      }
      return row;
    })();
    return branchDetailsInFlight.current[rowId];
  };

  const columns = [
     {
       dataField: "_id",
       hidden: true,
     },
     {
       dataField: "_id",
       formatter: (cell, row, rowIndex) => {
         return rowIndex + 1;
       },
       text: props.t("#"),
       headerStyle: (colum, colIndex) => {
         return { width: "5%" };
       },
     },
     {
       dataField: "name",
       text: props.t("Branch"),
       sort: true,
       headerStyle: (colum, colIndex) => {
         return { width: "15%" };
       },
     },
     {
       text: props.t("Opening"),
       dataField: "product_cost_opening",
       sort: true,
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },
        formatter: (cell, row) => {
          return row.product_cost_opening ? row.product_cost_opening : "0.00";
        },
     },
     {
       dataField: "product_purchase_cost",
       text: props.t("Purchase"),
       sort: true,
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },
       formatter: (cell, row, rowIndex) => {
        let isCentralKitchen = row.type === "CENTRAL KITCHEN STORE";
         return (
           <span
           className={`mr-2 text-info`}
           title={"View Details"}
           style={{ cursor: "pointer", pointerEvents: "auto"}}
             onClick={async () => {
              const full = await ensureBranchDetails(row);
              if (isCentralKitchen){
              let unique = mergeDuplicateProducts(full.product_purchase_details || [])
              let uniqueManualEntry = mergeDuplicateProducts(full.product_purchase_details_manual || [])
               setSelectedRow(unique);
               setSelectedBranch(full);
               setProductManualEntry(uniqueManualEntry);
               setFilterModalTotal(full.product_purchase_cost);
               setPurchaseModal(true);
              }else{
               let unique = mergeDuplicateProducts(full.product_order_details || [])
               setSelectedRow(unique);
               setSelectedBranch(full);
               setFilterModalTotal(full.product_purchase_cost);
               setPurchaseModal(true);
             }}
              }
           >
             {row.product_purchase_cost ? row.product_purchase_cost : "0.00"}
           </span>
         );
       },
     },
     {
       dataField: "product_outbound_transfer_cost",
       text: props.t("Out Tran"),
       sort: true,
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },    
       formatter: (cell, row, rowIndex) => {
        const isDisabled = row.type !== "Branch";
        const handleStoreOutbound = async () => {
          try {

            const dateRange = getDateRangeFromMonth(monthYear);
            const startDate = moment(dateRange.startDate);
            const endDate = moment(dateRange.endDate);
            const midDate = moment(dateRange.startDate).date(15);
        
            const firstHalfRange = {
              dateFrom: startDate.format('YYYY-MM-DD'),
              dateTo: midDate.format('YYYY-MM-DD')
            };
        
            const secondHalfRange = {
              dateFrom: midDate.add(1, 'days').format('YYYY-MM-DD'),
              dateTo: endDate.format('YYYY-MM-DD')
            };
        
            const url = process.env.REACT_APP_BASEURL + "reports/cogs_stores_products_outbound_details";
            
            const [firstHalfResponse, secondHalfResponse] = await Promise.all([
              postSubmitForm(url, {
                store_id: row._id,
                date_from: firstHalfRange.dateFrom,
                date_to: firstHalfRange.dateTo
              }),
              postSubmitForm(url, {
                store_id: row._id,
                date_from: secondHalfRange.dateFrom,
                date_to: secondHalfRange.dateTo
              })
            ]);
        
            if (firstHalfResponse?.status === 1 && secondHalfResponse?.status === 1) {
              const mergedData = mergeDuplicateItemsQuantityForStore([
                ...(firstHalfResponse.data.outbound_details || []),
                ...(secondHalfResponse.data.outbound_details || [])
              ],false);
              // console.log(mergedData.length,"mergedData length")
              // console.log(firstHalfResponse.data.outbound_details.length + secondHalfResponse.data.outbound_details.length,"response length")
              const totalofMerge = mergedData.reduce((partialSum, a) => Number(partialSum) + Number(a.receiving_cost),0);
              // console.log(firstHalfResponse.data.total_outbound_cost+secondHalfResponse.data.total_outbound_cost,"res total")
              // console.log(totalofMerge,"total");
              
              setSelectedBranch(row);
              setSelectedRow(mergedData);
              setFilterModalTotal(totalofMerge.toFixed(2));
              setProductOutboundModal(true);
            } else {
              showNotification(
                firstHalfResponse?.message || secondHalfResponse?.message || "Error fetching data", 
                "Error"
              );
            }
          } catch (error) {
            console.error("Error fetching store outbound data:", error);
            showNotification("Error loading data", "Error");
          } finally {

          }
        };
        const handleBranchOutbound = async () => {
          const full = await ensureBranchDetails(row);
          const filtered = full?.product_transfer_details?.filter(ob => ob.is_outbound) || [];
          const unique = mergeDuplicateProdQuantity(filtered);
          
          setSelectedBranch(full);
          setSelectedRow(unique);
          setFilterModalTotal(full.product_outbound_transfer_cost);
          setProductOutboundModal(true);
        };
      
        const handleClick = () => {
          if (isDisabled) {
            handleStoreOutbound();
          } else {
            handleBranchOutbound();
          }
        };
         return (
           <span
             className="text-info mr-2"
             title="View Details"
             style={{ cursor: "pointer" }}
             onClick={handleClick}
             >
             {row.product_outbound_transfer_cost
               ? row.product_outbound_transfer_cost
               : "0.00"}
           </span>
         );
       },
     },
     {
       dataField: "product_inbound_transfer_cost",
       text: props.t("In Tran"),
       sort: true,
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },
       formatter: (cell, row, rowIndex) => {
        let isDisabled = row.type !== "Branch";
         return (
           <span
           className={`mr-2 ${isDisabled ? '' : 'text-info'}`}
           title={isDisabled ? "Not available for this type" : "View Details"}
           style={{ 
            cursor: isDisabled ? "not-allowed" : "pointer",
            pointerEvents: isDisabled ? "none" : "auto"
          }}
             disabled={isDisabled}
             onClick={async () => {
              if (isDisabled) return;
               const full = await ensureBranchDetails(row);
               let filtered = full?.product_transfer_details?.filter((ob)=>ob.is_inbound) || []
               let unique = mergeDuplicateProdQuantity(filtered); 
               setSelectedRow(unique);
               setSelectedBranch(full);
               setFilterModalTotal(full.product_inbound_transfer_cost);
               setProductInboundModal(true)
             }}
           >
             {row.product_inbound_transfer_cost
               ? row.product_inbound_transfer_cost
               : "0.00"}
           </span>
         );
       },
     },
     {
       text: props.t("Closing"),
       dataField: "product_cost",
       sort: true,
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },
         formatter: (cell, row) => {
                    const params = `?month=${monthYear}&store_id=${row._id}`;
                    const currentMonthYear = moment().format("YYYY-MM")            
                    const isDisabled = monthYear !== currentMonthYear 
                    const isEmpty =  !Number(row?.product_cost)

                    if(!isDisabled){
                        return (
                            <Link 
                              to={`/products/branchwise_balance_report${params}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-info"
                              title="View Details"
                            >
                              {cell ? cell : "0.00"}
                            </Link>
                          );
                    } else{
                        return (
        <span
          className={`${isEmpty ? null : `text-info`}`}
          style={{ cursor: "pointer" }}
          onClick={async () => {
          if(isEmpty) return
          const full = await ensureBranchDetails(row);
          const details = full.product_details || [];
          if (!details.length) return;
          let total = details.reduce((partialSum, a) => Number(partialSum) + Number(a.total_cost), 0);
          setFilterModalTotal(Number(total.toFixed(2)))
            setSelectedBranch(full);
            setSelectedRow(details);
            setClosingModal(true)
          }}
          title="View Details"
        >
          {cell ? cell : "0.00"}
        </span>
      );
                    }
                          
                  }
     },
     {
       text: props.t("COGS"),
       dataField: "cogs",
       sort: true,
       sortFunc: (a, b, order, dataField, rowA, rowB) => {
         const cogsA = calculateCOGS(rowA);
         const cogsB = calculateCOGS(rowB);
     
         if (order === 'asc') {
           return cogsA - cogsB;
         }
         return cogsB - cogsA;
       },
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },
       formatter: (cell, row, rowIndex) => {
         let cogs =calculateCOGS(row)
 
         if (isNaN(cogs)) {
           cogs = "0.00";
         } else {
           cogs = cogs.toFixed(2);
         }
         return cogs;
       },
     },
     {
           text: props.t("Used"),
           dataField: "used_product_cost",
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "6%" };
           },
           formatter: (cell, row) => {
                   const params = `?month=${monthYear}&store_id=${row._id}`;
                   return (
                     <Link 
                       to={`/products/branchwise_used_cost_report${params}`}
                       target="_blank"
                       rel="noopener noreferrer"
                       className="text-info"
                       title="View Details"
                     >
                       {cell ? cell : "0.00"}
                     </Link>
                   );
                 },
         },
         {
           text: props.t("Waste"),
           dataField: "waste_product_cost",
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "5%" };
           },
           formatter: (cell, row) => {
                   const params = `?month=${monthYear}&store_name=${row.name}`;
                   return (
                     <Link 
                       to={`/products/branchwise_wasted_report${params}`}
                       target="_blank"
                       rel="noopener noreferrer"
                       className="text-info"
                       title="View Details"
                     >
                       {cell ? cell : "0.00"}
                     </Link>
                   );
                 },
         },
         {
           text: props.t("Discard"),
           dataField: "discard_product_cost",
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "6%" };
           },
            formatter: (cell, row) => {
                   const params = `?month=${monthYear}&store_name=${row.name}`;
                   return (
                     <Link 
                       to={`/products/branchwise_discarded_report${params}`}
                       target="_blank"
                       rel="noopener noreferrer"
                       className="text-info"
                       title="View Details"
                     >
                       {cell ? cell : "0.00"}
                     </Link>
                   );
                 },
         },
        //  {
        //    text: props.t("Diff"),
        //    dataField: "difference",
        //    sort: true,
        //    sortFunc: (a, b, order, dataField, rowA, rowB) => {
        //      const calcDifference = (row) => {
        //        const cogs = calculateCOGS(row);
         
        //          const usedItemCost = getPositiveNumber(row.used_product_cost) + 
        //          getPositiveNumber(row.waste_product_cost) + 
        //          getPositiveNumber(row.discard_product_cost)
     
        //        return Math.abs(cogs - usedItemCost);
        //      };
         
        //      const diffA = calcDifference(rowA);
        //      const diffB = calcDifference(rowB);
         
        //      if (order === 'asc') {
        //        return diffA - diffB;
        //      }
        //      return diffB - diffA;
        //    },
        //    headerStyle: (colum, colIndex) => {
        //      return { width: "5%" };
        //    },
        //    formatter: (cell, row, rowIndex) => {
        //      try {
        //        const cogs = calculateCOGS(row);
         
        //        const usedItemCost = getPositiveNumber(row.used_product_cost) + 
        //        getPositiveNumber(row.waste_product_cost) + 
        //        getPositiveNumber(row.discard_product_cost)
     
        //        const difference = Math.abs(cogs - usedItemCost);
         
        //        return isNaN(difference) ? "0.00" : difference.toFixed(2);
         
        //      } catch (error) {
        //        console.error('Error calculating difference:', error);
        //        return "0.00";
        //      }
        //    },
        //    footer: true,
        //  }
   ];
  const purchaseOrderTotal = selectedRow?.reduce((acc, cur) => acc + Number(cur.receiving_cost), 0) || 0;
  const productManualEntryTotal = productManualEntry?.reduce((acc, cur) => acc + Number(cur.receiving_cost), 0) || 0;

   const columnPurchase = columnsPurchase(
    props,
   loadPurchaseDetails,
    selectedRow,
    selectFilter,
    dynamicSort
  );

    const columnPurchaseForCK = columnsPurchase(
    props,
    (item_id)=>loadTabProductDetails(item_id,1),
    selectedRow,
    selectFilter,
    dynamicSort
  );

    const columnManualEntry = columnsPurchase(
        props,
    (item_id)=>loadTabProductDetails(item_id,2),
        selectedRow,
        selectFilter,
        dynamicSort,
        true
      );

  const columnPurchasedetails = columnsPurchaseDetails(props, selectFilter,monthYear);
  const columnsPurchaseTabDeatil = columnsPurchaseTabDeatils(props, selectFilter,activeTab);

  const columnsProductInBound = columnsProductInbound(
    props,
    loadProductInboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort
  );

  const columnsProductInBoundDetails = columnsProductInboundDetails(
    props,
    selectFilter,
    productInboundDetails,
    dynamicSort
  );

  const columnsProductOutBound = columnsProductOutbound(
    props,
    loadProductOutboundDetails,
    selectFilter,
    selectedBranch,
    dynamicSort
  );
  const columnsProducts = columnsProductDetails(props)
  const columnsProductOutBoundDetails = columnsProductOutboundDetails(
    props,
    selectFilter,
    productOutboundDetails,
    dynamicSort
  );

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const handleDownload = async () => {
      const fileName = `cogs_report_products_${monthYear}`;
      const exportType = "xls";
  
      let data_to_export = allOrders;
  
      if (data_to_export) {
        var data = [];
        JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
          let cogs = calculateCOGS(v);
          const totalUsedCost = getPositiveNumber(v.used_product_cost) + 
          getPositiveNumber(v.waste_product_cost) + 
          getPositiveNumber(v.discard_product_cost)
          if (isNaN(cogs)) {
            cogs = "0.00";
          } else {
            cogs = cogs.toFixed(2);
          }
          data.push({
            Branch: v.name,
            "Opening Cost": v.product_cost_opening,
            "Purchase Cost": v.product_purchase_cost,
            "Outbound Transfer": v.product_outbound_transfer_cost,
            "Inbound Transfer": v.product_inbound_transfer_cost,
            "Closing Cost": v.product_cost,
            COGS: cogs,
            Used: v.used_product_cost,
            Waste: v.waste_product_cost,
            Discard: v.discard_product_cost,
            // Diff: Math.abs(Number(cogs) - totalUsedCost).toFixed(2),
          });
        });
  
        exportFromJSON({ data, fileName, exportType });
      }
    };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("COGS Products - Monthly")}
            title={props.t("COGS Products")}
            breadcrumbItem={props.t("COGS Products - Monthly")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={4}>
                      <input
                        type="month"
                        name="monthYear"
                        label={props.t("Month-Year")}
                        value={monthYear}
                        disabled={isLoading}
                        onChange={(e, v) => {
                          setMonthYear(e.target.value);
                        }}
                        max={currentMonthYear}
                        className="is-touched is-pristine av-valid form-control"
                      />
                    </Col>
                    <Col lg={8} sm={8} className="text-right" >
                                          <Button
                                            type="submit"
                                            className="btn btn-sm btn-secondary"
                                            onClick={handleDownload}
                                          >
                                            <i className="mdi mdi-file-export"></i>{" "}
                                            {props.t("Export CSV")}
                                          </Button>
                                          {"   "}
                                          <Link
                                            to="#"
                                            onClick={() => {
                                              printDiv("printDiv");
                                            }}
                                            className="btn btn-sm btn-success mr-2"
                                          >
                                            <i className="fa fa-print"></i> Print
                                          </Link>
                                        </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                 {isLoading && 
                                <div className="mb-3">
                                <Progress
                                  animated
                                  color="info"
                                  value={progress}
                                  style={{ height: '20px',color:"Highlight",fontWeight:"bold" }}
                                >
                                  {Math.round(progress)}%  Loading...
                                </Progress>
                              </div>
                                }
                  {/* <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row> */}
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Products)")}
                      <br />
                      <h6>
                        (cogs = opening cost + purchase cost + inbound transfer
                        cost - outbound transfer cost - closing cost)
                      </h6>
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            noDataIndication={
                              isLoading 
                                ? <Spinner size={"md"}/> 
                                : ("No data to display.")
                            }
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
 {/*Opening  modal  start*/}
                     <Modal
                      size="xl"
                      isOpen={openingModal}
                      toggle={() => setOpeningModal(!openingModal)}
                    >
                      <ModalHeader
                        toggle={() => setOpeningModal(!openingModal)}
                      >
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("openingDetailsDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="openingDetailsDiv">
                          <Col lg={12}>
                            <Row>
                              <Col lg={4}>
                                {" "}
                                <img
                                  src={logo}
                                  alt=""
                                  height="50"
                                  style={{ borderRadius: "5px" }}
                                />{" "}
                              </Col>
                              <Col lg={4}>
                                <CardTitle className="text-center">
                                {props.t("Cost Of Goods Sold Report (Products)")}
                                </CardTitle>{" "}
                              </Col>
                            </Row>{" "}
                            <CardTitle className="text-center">
                              {props.t("(Opening Cost Details)")}
                            </CardTitle>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                  <h5>
                                      Branch : {selectedBranch.name} | Total Cost :{" "}
                                      {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                                    </h5>
                                    <BootstrapTable
                                      keyField="_id"
                                      data={selectedRow && selectedRow}
                                      columns={columnsProducts}
                                      striped
                                      bootstrap4
                                      hover
                                      condensed
                                      {...props.baseProps}
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
            {/*Opening  modal  end*/}
            {/*closing  modal  start*/}
                <Modal
                  size="xl"
                  isOpen={closingModal}
                  toggle={() => setClosingModal(!closingModal)}
                >
                  <ModalHeader toggle={() => setClosingModal(!closingModal)}>
                    <Link
                      to="#"
                      onClick={() => printDiv("printDivClosing")}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <i className="fa fa-print"></i> Print
                    </Link>
                  </ModalHeader>
                  <ModalBody>
                    <Row id="printDivClosing">
                      <Col lg={12}>
                        <Row>
                          <Col lg={4}>
                            <img
                              src={logo}
                              alt=""
                              height="50"
                              style={{ borderRadius: "5px" }}
                            />
                          </Col>
                          <Col lg={4}>
                            <CardTitle className="text-center">
                              {props.t("Cost Of Goods Sold Report (Products)")}
                            </CardTitle>
                          </Col>
                        </Row>
                        <CardTitle className="text-center">
                          {props.t("Closing Balance Details")}
                        </CardTitle>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col lg={12}>
                                <h5>
                                  Branch: {selectedBranch?.name} | Total Cost :{" "}
                                      {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                                </h5>
                                <BootstrapTable
                                  keyField="_id"
                                  data={selectedRow && selectedRow}
                                  columns={columnsProducts}
                                  striped
                                  hover
                                  condensed
                            />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
           {/*closing  modal  end*/}
          {/* Purchase breakup modal       */}
          <Modal
            size="xl"
            isOpen={purchaseModal}
            toggle={() => setPurchaseModal(!purchaseModal)}
          >
            <ModalHeader toggle={() => setPurchaseModal(!purchaseModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseProduct");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              {selectedBranch?.name==="CENTRAL KITCHEN STORE" ? (
              <>
               <Row id="printDivPurchaseProduct">
                <Col lg={12}>
                <Row>
   <Col lg={4}>
            <img
              src={logo}
              alt=""
              height="50"
              className="d-print-none"
              style={{ borderRadius: "5px" }}
            />
          </Col>
          <Col lg={4}>
            <CardTitle className="text-center">
            {props.t("Cost Of Goods Sold Report (Products)")}
            </CardTitle>
          </Col>
                  
                </Row>
                  <CardTitle className="text-center">
                    {props.t("Purchase Details")}
                  </CardTitle>
                <h5>
                            Store : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>

        <Nav tabs className="nav-tabs-custom w-100 mt-2">
          <div className="w-100 d-flex justify-content-center d-print-none">
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames({ active: activeTab === "1", "nav-link": true, })}
              onClick={() => setActiveTab("1") }
              style={{ cursor: "pointer" }}
            >
              {props.t("Purchase Details")}
            </NavLink>
          </NavItem>
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames({ active: activeTab === "2", "nav-link": true, })}
              onClick={() => setActiveTab("2")}
            >
              {props.t("Manual Entry")}
            </NavLink>
          </NavItem>
          </div>
        </Nav>

        <TabContent activeTab={activeTab} className="p-3">
          <TabPane tabId="1" key={1}>
            <Card>
              <CardBody>
                <Row >
                              {/* Hidden on screen, visible in print */}
  <h6 className="d-none d-print-block text-center mb-1" 
  style={{display:"flex", justifyContent:"center",textAlign:"center", fontSize:"20px"}}>
    {props.t("Purchase Order")}
  </h6>
  
                  <Col lg={12}>
                  <h5>Total :{" "}{Number(purchaseOrderTotal.toFixed(2).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}))} </h5>
                    <BootstrapTable
                      keyField="_id"
                      data={selectedRow && selectedRow}
                      columns={columnPurchaseForCK}
                      striped
                      hover
                      bootstrap4
                      filter={filterFactory({afterFilter})}
                      condensed
                      rowStyle={rowStyle}
                      {...props.baseProps}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="2" key={2}>
            <Card>
              <CardBody>
                <Row>
                              {/* Hidden on screen, visible in print */}
  <h6 className="d-none d-print-block text-center mb-1" 
  style={{display:"flex", justifyContent:"center",textAlign:"center", pageBreakBefore:"always", fontSize:"20px"}}>
    {props.t("Manual Entry")}
  </h6>
                  <Col lg={12}>
                  <h5>Total :{" "}{Number(productManualEntryTotal.toFixed(2).toLocaleString('en-QA', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }))} </h5>
                    <BootstrapTable
                      keyField="_id"
                      data={productManualEntry && productManualEntry}
                      columns={columnManualEntry}
                      striped
                      hover
                      bootstrap4
                      filter={filterFactory({afterFilter})}
                      condensed
                      rowStyle={rowStyle}
                      {...props.baseProps}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </TabPane>
        </TabContent>
                </Col>
        </Row>
                
              </>
              ):
              (<>
              <Row id="printDivPurchaseProduct">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>
                    </Col>
                    <Col lg={4}></Col>
                  </Row>

                  <CardTitle className="text-center">
                    {props.t("(Product Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>

                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnPurchase}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
               </>)}
              
            </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseProdu");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              {selectedBranch?.type === "CENTRAL KITCHEN STORE" ? (
              <>
            <Row id="printDivPurchaseProdu">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        className="d-print-none"
                        style={{ borderRadius: "5px"}}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {activeTab == 1 ?  props.t("(Purchase Order Details)") : (props.t("(Manual Entry Details)"))}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                       <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
    marginTop: "10px",
    width: "100%",
    whiteSpace: "nowrap",  
  }}
>
  <div>
    <h5 style={{ margin: 0 }}>Store: {selectedBranch.name}</h5>
  </div>
  <div>
    <h5 style={{ margin: 0 }}>
      Total Qty: {formatUnitsForReport(filterModalTotalQty)}
    </h5>
  </div>
  <div>
    <h5 style={{ margin: 0 }}>
      Total:{" "}
      {filterModalSubTotal.toLocaleString("en-QA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </h5>
  </div>
</div>

                         <BootstrapTable
                            keyField="row_key"
                            data={centralKitchenTabDetails && centralKitchenTabDetails}
                            columns={columnsPurchaseTabDeatil}
                            striped
                            hover
                            bootstrap4
                             filter={filterFactory({
                              afterFilter: (newResult) => {
                                  setTimeout(() => {
                                    afterFilterForTabDetails(newResult,"receive","delivery_details")
                                  }, 200);
                                 return newResult
                              }
                            })}
                            condensed
                            rowStyle={rowStyle}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              </>
              ):(
                <>
                <Row id="printDivPurchaseProdu">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("Product Order")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>       
                         <BootstrapTable
                            keyField="_id"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnPurchasedetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({afterFilter})}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              </>
            )}
              
            </ModalBody>
          </Modal>

          {/*Product Outbound modal       */}
          <Modal
            size="xl"
            isOpen={productOutboundModal}
            toggle={() => setProductOutboundModal(!productOutboundModal)}
          >
            <ModalHeader
              toggle={() => setProductOutboundModal(!productOutboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProdOutbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProdOutbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Product Outbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProductOutBound}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product outbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productOutboundDetailsModal}
            toggle={() =>
              setProductOutboundDetailsModal(!productOutboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setProductOutboundDetailsModal(!productOutboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiviProdOutbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiviProdOutbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Transfer Outbound")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Outbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                                <BootstrapTable
                            keyField="_id"
                            data={
                              productOutboundDetails && productOutboundDetails
                            }
                            columns={columnsProductOutBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Inbound modal       */}
          <Modal
            size="xl"
            isOpen={productInboundModal}
            toggle={() => setProductInboundModal(!productInboundModal)}
          >
            <ModalHeader
              toggle={() => setProductInboundModal(!productInboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProdInbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProdInbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Product Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProductInBound}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Inbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productInboundDetailsModal}
            toggle={() =>
              setProductInboundDetailsModal(!productInboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setProductInboundDetailsModal(!productInboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiviProdInbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiviProdInbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Inbound Transfer")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                                <BootstrapTable
                            keyField="_id"
                            data={
                              productInboundDetails && productInboundDetails
                            }
                            columns={columnsProductInBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(CostOfGoodsSoldProductsReport))
);
